import { Analytics } from "utils/analytics"

export function subscribeOnContextMenu(fn: (event: MouseEvent) => void) {
    document.addEventListener("contextmenu", fn)
    return () => document.removeEventListener("contextmenu", fn)
}

function isImageUnderCursor(pageX: number, pageY: number) {
    return document.elementFromPoint(pageX, pageY) instanceof HTMLImageElement
}

export function createContextMenuHandler(psyDisplayName: string, from: string) {
    return (event: MouseEvent) => {
        const selection = document.getSelection()?.toString()
        if (typeof selection === "string") {
            if (selection.length) {
                if (selection.includes(psyDisplayName.replace(/\.$/, ""))) {
                    Analytics.context_menu_opened_while_psy_selected({ from })
                }
            } else if (isImageUnderCursor(event.pageX, event.pageY)) {
                Analytics.context_menu_opened_while_psy_selected({ from })
            }
        }
    }
}
